export default function(){
    const allQuotes = [
        "No problemo!",
        "Who is your daddy and what does he do?",
        "I need a vacation.",
        "Sarah Connor?",
        "I need you clothes, your boots, and your motorcycle.",
        "Hasta la vista, baby.",
        "You should not drink and bake.",
        "Who said you could eat my cookies?",
        "PUT THAT COOKIE DOWN! NOW!",
        "Get your ass to Mars.",
        "GET TO THE CHOPPA!",
        "Come with me if you want to live.",
        "I'll be back",
        "Now listen to me very carefully ...",
        "You are not you, you are me.",
        "I'm the famous comedian Arnold Braunschweiger.",
    ];

    let remainingQuotes = allQuotes;

    //Returns the next quote which hasn't been previously shown in this instance
    this.nextQuote = function(){

        //const nextIndex = Math.floor(Math.random()* remainingQuotes.length);
        //return remainingQuotes[nextIndex];

        //If no more quotes left, start over
        if (remainingQuotes.length <= 0)
            remainingQuotes = allQuotes;

        const nextIndex = Math.floor(Math.random()* remainingQuotes.length);
        const quote = remainingQuotes[nextIndex];

        let quotesBefore = remainingQuotes.slice(0, nextIndex);
        let quotesAfter = remainingQuotes.slice(nextIndex + 1, remainingQuotes.length);

        remainingQuotes = quotesBefore.concat(quotesAfter);

        return quote;
    }
}